<template>

    <router-view></router-view>

</template>
<script>
export default {
	beforeRouteUpdate(to, from, next) {
		if(to.name == 'Cursos'){
			next({ name: 'GerenciarCursos' })
		}else{
			next()
		}
	},
	created() {
		if(this.$route.name == 'Cursos'){
			this.$router.push({ name: 'GerenciarCursos' })
		}
	}
}
</script>